export const inputs = [
  { id: "firstName", label: "First Name" },
  { id: "lastName", label: "Last Name" },
  { id: "title", label: "Title" },
  { id: "email", label: "Business Email" },
  { id: "phone", label: "Phone Number" },
  { id: "company", label: "Company" },
  { id: "msg", label: "Message" },
];
